<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M0 3.227v9.7c0 .59.478 1.067 1.067 1.067h13.866c.587 0 1.064-.474 1.067-1.061V3.227c0 .065-.03.126-.08.167L8.333 9.467a.533.533 0 0 1-.666 0L.08 3.397a.213.213 0 0 1-.08-.17Z" transform="translate(0 1)" fill="currentColor"/><path d="M0 1.067V4c0 .065.03.126.08.167l7.587 6.069a.533.533 0 0 0 .666 0l7.587-6.069c.05-.04.08-.102.08-.167V1.067C16 .477 15.522 0 14.933 0H1.067C.477 0 0 .478 0 1.067Z" opacity=".45" transform="translate(0 1)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering182',
});
</script>
